module.exports = __webpack_public_path__ + "static/media/notifyi-logo-solid-light.249a5ba6.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/notifyi-logo-solid-light.png
 ** module id = 175
 ** module chunks = 0
 **/